import React from 'react';
import { classes } from '../../../lib';
import Styles from './SocialValidation.module.less';

export type SocialValidationProps = {
    children: React.ReactNode;
    title: string;
    labels?: React.ReactNode;
};

export const SocialValidation = ({
    title,
    children,
    labels,
}: SocialValidationProps): JSX.Element => {
    return (
        <div className="vertical stretch-top g28 lp-section">
            <span className="text-center h3-alude alude-gray-8">{title}</span>
            <div className={classes('horizontal left-middle', Styles.logos)}>
                <div className="horizontal around-middle">{children}</div>
                <div className="horizontal around-middle">{children}</div>
            </div>
            <div
                className={classes(
                    'd-horizontal d-center-middle gx40 gy8 mt-vertical wrap mt-stretch-top semilarge-alude',
                    Styles.labels
                )}>
                {labels}
            </div>
        </div>
    );
};
